"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconShareFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M10.7474 2.33568C10.4716 2.02537 10.0327 1.91777 9.64462 2.06532C9.25654 2.21287 9 2.58486 9 3.00004V5.06485C7.14136 5.30878 5.61505 6.21406 4.39163 7.32096C2.96709 8.60983 1.90619 10.2128 1.14255 11.4855C0.893505 11.9006 0.977507 12.4344 1.34198 12.753C1.70646 13.0715 2.24675 13.0833 2.62474 12.7809C3.89305 11.7662 4.73994 11.1064 5.75765 10.6686C6.57625 10.3165 7.55262 10.091 9 10.0223V12C9 12.4152 9.25654 12.7872 9.64462 12.9348C10.0327 13.0823 10.4716 12.9747 10.7474 12.6644L14.7474 8.16441C15.0842 7.78552 15.0842 7.21457 14.7474 6.83568L10.7474 2.33568Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M12.6757 3.26287C12.3834 2.9949 11.9603 2.92499 11.5973 3.08467C11.2343 3.24435 11 3.60345 11 4.00002V7.10389C5.21694 7.95981 2.53529 12.6935 1.10565 15.5528C0.890329 15.9834 1.01245 16.5064 1.39623 16.7971C1.78002 17.0878 2.31649 17.0638 2.67275 16.7399C4.04266 15.4946 5.13188 14.5891 6.47923 13.9716C7.62794 13.4451 9.01986 13.1045 11 13.0204V15C11 15.3966 11.2343 15.7557 11.5973 15.9154C11.9603 16.0751 12.3834 16.0051 12.6757 15.7372L18.6757 10.2372C18.8824 10.0478 19 9.78033 19 9.50002C19 9.21971 18.8824 8.95228 18.6757 8.76287L12.6757 3.26287Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M15.6178 5.21369C15.3168 4.97717 14.9072 4.93327 14.5629 5.10061C14.2186 5.26796 14 5.61719 14 6.00001V9.09458C7.07878 9.97503 2.91706 14.93 1.10565 18.5528C0.890329 18.9834 1.01245 19.5064 1.39623 19.7971C1.78002 20.0878 2.31649 20.0638 2.67275 19.7399C4.27797 18.2807 5.85879 17.1095 7.76764 16.2947C9.45802 15.5732 11.4495 15.1128 14 15.0182V18C14 18.3977 14.2357 18.7577 14.6003 18.9166C14.9649 19.0756 15.389 19.0034 15.6805 18.7328L22.6805 12.2328C22.8947 12.0338 23.0112 11.751 22.9992 11.4588C22.9871 11.1666 22.8478 10.8944 22.6178 10.7137L15.6178 5.21369Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M20.4968 6.37891C20.0553 5.98648 19.4246 5.88969 18.8858 6.13167C18.3469 6.37364 18.0002 6.90934 18.0002 7.50003V11.2157C14.5392 11.9017 11.3598 13.6953 8.74776 15.8409C5.80252 18.2602 3.46196 21.2217 2.15823 23.8292C1.83525 24.4751 2.01843 25.2596 2.59411 25.6957C3.16978 26.1318 3.97449 26.0957 4.50888 25.6099C6.67526 23.6405 8.42079 22.283 10.5768 21.3846C12.4548 20.6021 14.7369 20.1313 18.0002 20.0237V23.5C18.0002 24.0907 18.3469 24.6264 18.8858 24.8684C19.4246 25.1104 20.0553 25.0136 20.4968 24.6211L29.4968 16.6211C29.817 16.3365 30.0002 15.9285 30.0002 15.5C30.0002 15.0716 29.817 14.6636 29.4968 14.3789L20.4968 6.37891Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;